/**
 * Seleção de características da mesa (TRPGTagSelectionLayout): o catálogo do
 * RPG Desk como fichas clicáveis. `exclude` desabilita as que já estão na outra
 * lista (busca: desejadas × indesejadas).
 */
import { useT } from '../i18n/index.js';
import { ROOM_TAGS } from '../shared.js';

export function TagSelector({ value, onChange, exclude = [], max }: { value: string[]; onChange: (tags: string[]) => void; exclude?: string[]; max?: number }) {
  const t = useT();
  const full = max !== undefined && value.length >= max;
  return (
    <div className="rd-tags" role="group">
      {ROOM_TAGS.map((tag) => {
        const on = value.includes(tag);
        const blocked = exclude.includes(tag) || (!on && full);
        return (
          <button
            key={tag}
            type="button"
            className={`rd-tag${on ? ' rd-tag--on' : ''}`}
            aria-pressed={on}
            disabled={blocked}
            onClick={() => onChange(on ? value.filter((v) => v !== tag) : [...value, tag])}
          >
            {t(`roomTag.${tag}`)}
          </button>
        );
      })}
    </div>
  );
}
